module.exports = __webpack_public_path__ + "img/monarch-ui-icon_INTERACTIONS.7aad1b54.png";